module.exports = __webpack_public_path__ + "static/media/19ESCAP37.1b120691.jpg";